import {
  formatBaseQty,
  formatInvStatusLabel,
  formatInventoryStockStatusLabel,
  formatWarehouseLocation,
  resolveInventoryStockMaterial,
} from '#/modules/imsMgmt/inventoryStock/helper/inventoryStockFilterOptions';

export const inventoryStockSideMsgBlocks = [
  {
    fields: [
      { label: '庫存編號', value: 'stockNo' },
      { label: '料號', value: (row) => resolveInventoryStockMaterial(row)?.mtrNo ?? '-' },
      { label: '名稱', value: (row) => resolveInventoryStockMaterial(row)?.name ?? '-' },
      {
        label: '主分類',
        value: (row) => resolveInventoryStockMaterial(row)?.mtrStructMain?.name ?? '-',
      },
      {
        label: '次分類',
        value: (row) => resolveInventoryStockMaterial(row)?.mtrStructSub?.name ?? '-',
      },
      { label: '倉別／儲位', value: (row) => formatWarehouseLocation(row) },
      {
        label: '庫存狀態',
        value: (row) => formatInvStatusLabel(row.invStatus ?? row.inventoryStatus),
      },
      { label: '狀態', value: (row) => formatInventoryStockStatusLabel(row.status) },
      { label: '數量', value: (row) => formatBaseQty(row) },
      { label: '備註', value: 'remark' },
    ],
  },
];
